import {
  CoverageArrowRow,
  CoverageDividerRow,
  NotProvidedRow,
} from "../table/rows";
import { CoverageCell } from "../table/cells";
import { Plan } from "../../constants/aquafina";
import { RangeIterator } from "../../utils";

import CollapsableSection from "./collapsable-section";

type ContributionTypeProps = {
  plans: Plan[];
  cellColSpan?: number;
};

const ContributionType = ({
  plans,
  cellColSpan = 1,
}: ContributionTypeProps) => (
  <CollapsableSection
    numberOfColumns={plans.length * cellColSpan}
    title="Contribution Type"
  >
    <ContributionTypeData plans={plans} cellColSpan={cellColSpan} />
  </CollapsableSection>
);

const ContributionTypeData = ({
  plans,
  cellColSpan = 1,
}: ContributionTypeProps) => {
  const contributionTypes = new Map<string, string[]>();
  RangeIterator(plans.length, (index) => {
    const plan = plans[index];
    plan.contributionTypes.forEach((contribution) => {
      if (!contributionTypes.has(contribution.class)) {
        contributionTypes.set(
          contribution.class,
          new Array(plans.length).fill(""),
        );
      }
      (contributionTypes.get(contribution.class) as string[])[index] =
        contribution.contributionType;
    });
  });

  const contributionTypesArray = Array.from(contributionTypes.entries());
  if (contributionTypesArray.length === 0) {
    return <NotProvidedRow colSpan={plans.length * cellColSpan} />;
  }

  return (
    <>
      <CoverageDividerRow
        label="Benefit Classes"
        totalPlans={cellColSpan * plans.length}
        isWhite={true}
      />
      {contributionTypesArray.map(([className, types], index) => (
        <CoverageArrowRow
          key={className}
          label={className}
          isWhite={index % 2 === 1}
        >
          {types.map((type, typeIndex) => (
            <CoverageCell key={typeIndex} value={type} colSpan={cellColSpan} />
          ))}
        </CoverageArrowRow>
      ))}
    </>
  );
};

export default ContributionType;
